import { IPagedCollection, LeadBulkUpdateDto, LeadBulkUpdateResultDto, LeadDto } from '@sr/dto';
import { CollectionParams } from '../../shared/api/rtk-query';
import { LEAD_BASE_URL } from '../../shared/api/api';
import { pagingDataToParams } from '../../utils/remote-paged-collection.hook';
import { leadBaseApi } from './api';
import { salaryApi } from 'entities/salary/salary.api';

const injectedLeadsListApi = leadBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeadsList: builder.query<IPagedCollection<LeadDto>, CollectionParams>({
      query: ({ paging, filter }) => ({
        url: `${LEAD_BASE_URL}/?${filter}`,
        params: paging && pagingDataToParams(paging)
      })
    }),
    bulkUpdateLeads: builder.mutation<LeadBulkUpdateResultDto | null, LeadBulkUpdateDto>({
      query: (dto) => ({
        url: `${LEAD_BASE_URL}`,
        body: dto,
        method: 'PUT'
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(salaryApi.util.invalidateTags(['workShifts']));
        } catch (error) {
          console.error('Failed to invalidate work shifts after lead bulk update', error);
        }
      }
    })
  })
});

export const leadsListApi = injectedLeadsListApi.enhanceEndpoints({
  endpoints: {
    getLeadsList: {
      providesTags: (result, error, query) => (
        result ?
          [{
            type: 'lead-list'
          }]
          : ['lead-list']
      )
    },
    bulkUpdateLeads: {
      invalidatesTags: [{ type: 'lead-list' }]
    }
  }
});
